import { FC } from 'react'
import { useLocation } from 'react-router-dom'

import { useStore } from 'store/useStore'
import { TextPromo } from 'components/ui'
import { Flex } from 'components/uiKit/Flex/Flex'
import { useResize } from 'utils/hooks/useResize'
import { PromoRoutesEnum } from 'shared/constants/routes'
import { SCROLL_TO_ID } from 'shared/constants/values'

import { OpenPickPointForm } from '../../shared/OpenPickPointForm/OpenPickPointForm'

import pickpointImg from 'assets/img/promo-page/pickpoint.webp'
import houseImg from 'assets/img/promo-page/simplified-conditions/houseImg.webp'
import s from './Authorization.module.scss'

export const Authorization: FC = () => {
  const { isMobile, isTablet } = useResize()
  const location = useLocation()
  const { appStore } = useStore()

  const isUserAuth = appStore?.user.authenticated

  const isSimplified = location.pathname === PromoRoutesEnum.simplifiedConditions

  return (
    !isUserAuth && (
      <section className={s.Authorization} id={SCROLL_TO_ID.authForm}>
        <div className={s.sectionWrapper}>
          <div className={s.title}>
            <TextPromo center weight="w700" size={isTablet ? (isMobile ? 's32' : 's40') : 's70'}>
              Хотите открыть пункт выдачи?
            </TextPromo>
          </div>
          <Flex className={s.contentWrapper}>
            <div className={s.formWrapper}>
              <OpenPickPointForm />
            </div>
            <div className={s.imageWrapper}>
              <img src={isSimplified ? houseImg : pickpointImg} className={s.image} />
            </div>
          </Flex>
        </div>
      </section>
    )
  )
}
